<!-- =========================================================================================
    File Name: TechnicEdit.vue
    Description: Edit technic component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="technicEdit" class="xbig y400">
    <vs-prompt :vs-title="'Kaydı Görüntüle Garaj #' + this.technicItemId" vs-accept-text="Çıkış" vs-cancel-text="Kapat" vs-button-cancel="border" @vs-cancel="cancel" @vs-close="close" :vs-is-valid="validateForm" :vs-active.sync="activePrompt">
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Adı Soyadı:</b>
            </label>
            <a :href="'/contactsView/' + currentItem.customerId" style="margin-left:15px;margin-top:5px" target="_blank">{{ currentItem.customerName + " ( " + currentItem.customerId + " ) " }}</a>
          </div>

          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Telefon:</b>
            </label>
            <span name="phone" class="w-full">
              <a href="tel:">{{ currentItem.customerPhone }}</a> ( <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4" />)
            </span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Cihazı Getiren:</b>
            </label>
            <span name="musteriAd" class="w-full">{{ currentItem.deliveredBY }}</span>
          </div>

          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Fotoğraflar</b>
            </label>

            <div class="vx-row">
              <div class="vx-col lg:w-1/3 w-full flex items-center">
                <span v-if="currentItem.imageList == null">Fotoğraf Yok</span>
                <div v-for="(src, index) in currentItem.imageList" :key="index" @click="() => showImg(index)">
                  <img style="width=32px; height:32px;" class="mr-2" :src="src" />
                </div>
              </div>
            </div>
          </div>
          <vue-easy-lightbox moveDisabled :visible="visible" :imgs="currentItem.imageList" :index="index" @hide="handleHide"></vue-easy-lightbox>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Adresi:</b>
            </label>
            <span name="musteriAdres" class="w-full">{{ currentItem.customerAddress }}</span>
          </div>
          <div class="vx-col w-1/2">
            <label class="w-full">
              <b>Getirildiği Tarih:</b>
            </label>
            <span name="serviceRegisterDate" class="w-full">{{ currentItem.deliveredDate }}</span>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <label class="w-full">
              <b>Aksesuarlar:</b>
            </label>
            <span style="padding: 2px 10px; line-height: 1.6em;">
              <b>{{ currentItem.orderNote }}</b>
            </span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="w-full" style></label>
            <span id="lblNotes" disabled="disabled" class="w-full"></span>
            <br />
          </div>
        </div>
        <div class="vx-row mt-1">
          <div class="vx-col w-full" v-if="!!this.currentItem.products && this.currentItem.products.length > 0 && this.currentItem.products[0].productId > 0">
            <div class="vx-col w-full">
              <vs-table noDataText="Tabloda Veri Yok" :data="currentItem.products">
                <template slot="thead">
                  <vs-th hidden>productId</vs-th>
                  <vs-th class="w-3/4">Ürün</vs-th>
                  <vs-th>Miktar</vs-th>
                  <vs-th>Fiyat</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="i.toString()" v-for="(tr, i) in data">
                    <vs-td hidden :data="data[i].productId">{{ data[i].productId }}</vs-td>
                    <vs-td :data="data[i].productName">
                      <div v-if="data[i].lineType != 3">
                        <b v-if="tr.productName.serialNumber"> {{ tr.productName.serialNumber ? "[" + tr.productName.serialNumber + "] " : "" }}</b
                        >&nbsp;{{ tr.productName.name }}
                      </div>
                      <div v-if="data[i].lineType == 3">{{ beautifyVehicle(data[i].productName) }}</div>
                    </vs-td>
                    <vs-td :data="data[i].productAmount">
                      {{ data[i].productAmount }}
                    </vs-td>
                    <vs-td :data="data[i].price">{{ data[i].price }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-1/2">
            <h6 class="w-full mt-2">Servis Tipi</h6>

            <span>{{ currentItem.serviceType }}</span>
          </div>
          <div class="vx-col w-1/2">
            <h6 class="w-full mt-2">Servis Durumu</h6>
            <span class="px-5" style="background-color: rgba(255, 159, 67, 0.3);">
              <b>{{ currentItem.serviceStatus }}</b>
            </span>
          </div>
        </div>

        <div class="vx-row mt-2" v-if="isAdmin()">
          <div class="vx-col w-1/2"></div>
          <div class="vx-col w-1/2">
            <div class="vx-row mt-2">
              <div class="vx-col w-1/2"></div>
            </div>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

export default {
  components: {
    flatPickr,
    vSelect,
    VueEasyLightbox,
  },
  props: {
    displayPrompt: {
      type: Boolean,
      required: true,
    },
    technicItemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
      searchResultsVisibilty: false,
      searchQuery: "",
      currentServiceNote: "",
      currentItem: {},
      previousNotes: "",
      getUserModel: {
        id: this.technicItemId,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      customerSearch: [],
      completed: false,
    };
  },
  //TODO: esc ile popup kapatma işlemlerı yarım// yeni kayıt sayfasında eğer ıkıncı sekme açılmıssa çalışmıcak seılde olmalı ayrıca yenı kayıt sayfasında bosluga tıklayınca da kapanmasının engellenmesı gereklı
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.$emit("hideDisplayPrompt", false);
      }
    });
  },
  methods: {
    //open pic with click
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    //hide pic with click
    handleHide() {
      this.visible = false;
    },

    selectItem(i) {
      this.selectedItem = JSON.parse(JSON.stringify(this.customerSearch[i]));
      this.selectedItem.firstName = this.selectedItem.firstName + " " + this.selectedItem.lastName;
      this.orderCreatingProperties.customerId = this.selectedItem.customerId;
    },
    search: async function() {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);

      return this.customerSearch;
    },
    beautifyVehicle(curr) {
      let ret = "";
      ret += curr.name + " Yıl: ";
      ret += curr.modelYear + " Kapasite: ";
      ret += curr.engineCapacity + " Yakıt: ";
      switch (curr.fuel) {
        case "B":
          ret += "Benzin";
          break;
        case "D":
          ret += "Dizel";
          break;
        case "L":
          ret += "LPG";
          break;
      }
      ret += " Km: ";
      ret += curr.mileage + "\nBelge No: ";
      ret += curr.documentNumber + " VIN: ";
      ret += curr.vin + " Şasi: ";
      ret += curr.engineNo + "";
      return ret;
    },
    beautifyServiceNotes(currentItem, prop) {
      this.previousNotes = "<br/><b> Müşteri Şikayeti: </b>" + currentItem[prop].customer + "<br/><hr/><br/><b>Teknik Servis Notu</b><br/>";
      if (Array.isArray(currentItem[prop].technic)) {
        let ctr = 1;
        for (var i = 0; i < currentItem[prop].technic.length; i++) {
          if (currentItem[prop].technic[i].trim().length > 0) {
            this.previousNotes += "<b>" + ctr + ")</b> " + currentItem[prop].technic[i] + "<br/>";
            ctr++;
          }
        }
      } else {
        if (currentItem[prop].technic.trim().length > 0) this.previousNotes += ": 1. " + currentItem[prop].technic + "<br/>";
      }
      document.getElementById("lblNotes").innerHTML = this.previousNotes;
    },
    getCurrentItem: async function() {
      if (!(this.technicItemId > 0)) {
        this.$vs.notify({
          title: "Hata",
          text: "Servis bilgisi alınamadı garaj!",
          color: "primary",
        });
        this.loading = false;
        return;
      }
      let a = await repository
        .postEntity("technic/getOrders", this.getUserModel)
        .then((r) => r.list)
        .then((r) => r[0]);
      a = repository.convertToJSON(a, "products");
      let b = repository.convertToJSON(a.products, "productName");
      for (let i = 0; i < b.length; i++) {
        b[i].productName = b[i].productName[0];
      }
      a = repository.convertToJSON(a, "serviceNote");
      if (typeof a.serviceNote != "object" || !a.serviceNote.customer || !a.serviceNote.technic) {
        a.serviceNote = { customer: "", technic: [] };
      }
      this.beautifyServiceNotes(a, "serviceNote");
      this.currentItem = a;
      if (this.currentItem.imageList) {
        this.currentItem.imageList = JSON.parse(this.currentItem.imageList);
        for (let i = 0; i < this.currentItem.imageList.length; i++) {
          this.currentItem.imageList[i] = "https://panel.nitrobilisim.com.tr/files/images/" + this.currentItem.imageList[i].path;
        }
      }
      this.currentItem.deliveredDate = new Date(this.currentItem.deliveredDate).toLocaleDateString();
      //onayla butonu sil
      let dialog = document.querySelector(".vs-dialog");
      dialog.querySelector("footer").firstElementChild.remove();
      return this.currentItem;
    },
    toggleIsImportant() {
      this.isImportantLocal = !this.isImportantLocal;
    },
    toggleIsStarred() {
      this.isStarredLocal = !this.isStarredLocal;
    },
    cancel() {
      if (this.$route.params != null && this.$route.name == "GarageById" && this.$route.params.serviceId > 0) {
        window.location.href = "../Garage";
      }
    },

    isAdmin() {
      return false;
      // eslint-disable-next-line
      return this.$store.state.userData.role === "Admin";
    },

    close() {
      if (this.$route.params != null && this.$route.name == "GarageById" && this.$route.params.serviceId > 0) {
        window.location.href = "../Garage";
      }
    },
  },
  created() {
    this.currentItem.serviceNote = { customer: "", technic: "" };
    this.getCurrentItem();
    if (localStorage["technicstatusList"]) this.serviceStatus = JSON.parse(localStorage["technicstatusList"]);
    if (localStorage["technictypeList"]) this.technictype = JSON.parse(localStorage["technictypeList"]);
  },

  watch: {
    selectedstatueLocal(d) {
      if (d == "Onarımda") {
        this.toggleIsImportant();
        this.isStarredLocal = false;
      } else {
        this.toggleIsStarred();
        this.isImportantLocal = false;
      }
    },
  },
  computed: {
    activePrompt: {
      get() {
        return this.displayPrompt;
      },
      set(value) {
        this.$emit("hideDisplayPrompt", value);
      },
    },

    validateForm() {
      return !this.errors.any() && this.musteriTelefonLocal != "" && this.musteriAdSoyadLocal != "" && this.musteriAdresLocal != "" && this.cihazMarkaLocal != "" && this.cihazModelLocal != "";
    },
    isTrashed: {
      get() {
        return 0;
      },
      set(value) {
        this.$store.dispatch("technic/moveToTrash", {
          id: this.technicItemId,
          value: value,
        });
      },
    },
  },
};
</script>
